import { render, staticRenderFns } from "./VisitaGastroenterologicaEditComponent.vue?vue&type=template&id=3a49b24c"
import script from "./VisitaGastroenterologicaEditComponent.vue?vue&type=script&lang=js"
export * from "./VisitaGastroenterologicaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports